( function ( _s ) {
	_s.fn.learndashForms = function () {
		return this.each( el => {
			const _self = _s( el );
			const _forms = _self.find(
				'form#loginform, form#learndash_registerform, #learndash-reset-password-wrapper form'
			);

			_forms.each( form => {
				_s( form ).closest( '.fr-content-row' ).addClass( 'section-bg-gray-1' );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( 'body.single-sfwd-courses, body.single-groups, body.registration' ).learndashForms();
	} );
} )( window._s );
